import {createAction} from '@reduxjs/toolkit';

export const setView = createAction('MAP_SET_VIEW');
export const setZoom = createAction('MAP_SET_ZOOM');
export const setSize = createAction('MAP_SET_SIZE');
export const toggleLabels = createAction('MAP_TOGGLE_LABELS');
